<template>
  <a :href="tourUrl" class="tour-item">
    <div class="flex flex-1 min-h-[6em] mx-2 my-2">
      <div class="flex h-28 w-28 relative overflow-hidden bg-gray-200 rounded-lg">
        <img v-if="tour.main_picture?.preview_url"
             class="object-cover h-full w-full"
             :alt="showMultiLingualText(tour.introduction_title, null, true)"
             :src="tour.main_picture.preview_url" />
      </div>
      <div class="flex flex-1 flex-col px-3 overflow-hidden justify-between">
        <div>
          <p class="text-sm font-bold line-clamp-2">
            {{ showMultiLingualText(tour.introduction_title, null, true) }}
          </p>
          <p class="text-sm line-clamp-4 pt-1">
            {{ showMultiLingualText(tour.introduction_text, null, true) }}
          </p>
        </div>
      </div>
      <div class="flex items-center p-2">
        <ChevronRightIcon class="w-5 h-5 text-gray-400" />
      </div>
    </div>
  </a>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getBasePath, showMultiLingualText } from '@/utils/shared/language'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'TourListItem',
  components: {
    ChevronRightIcon
  },
  props: {
    tour: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const route = useRoute()
    
    const tourUrl = computed(() => {
      const currentPath = getBasePath(route.path)
      return `//${props.tour.domain}/${props.params.language || ''}${currentPath}`
    })
    
    return {
      tourUrl,
      showMultiLingualText
    }
  }
}
</script>
